// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__KdHiX","file":"styles_file__2LTYB"};